import React from 'react';
import { Box } from '@material-ui/core';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import SelectionBar from 'components/UI/SelectionBar/SelectionBar';
import SearchBar from 'components/UI/V3/SearchBar/SearchBar';
import MembershipDetailsTable from './MembershipDetailsTable';
import { EnrollmentFilterOption } from '..//SoldMemberships/hooks/useEnrollmentFilters';

interface EnrollmentListViewProps {
    title: React.ReactNode;
    showSellButton?: boolean;
    onSellClick?: () => void;
    buttonLabel?: string;
    onBack?: () => void;
    customButton?: React.ReactNode;
    filters: {
        options: EnrollmentFilterOption[];
        selectedId: string;
        onSelect: (id: string) => void;
        className?: string;
    };
    search: {
        value: string;
        setValue: (value: string) => void;
        className?: string;
        placeholder?: string;
        rightActions?: React.ReactNode;
    };
    tableProps: React.ComponentProps<typeof MembershipDetailsTable>;
    children?: React.ReactNode;
    classes: {
        wrapperContainer: string;
        headWrapper: string;
        alertsContainer: string;
        content: string;
        headerContainer: string;
    };
    alerts?: React.ReactNode;
    headerContent?: React.ReactNode;
    emptyDescription?: string;
}

const EnrollmentListView: React.FC<EnrollmentListViewProps> = ({
    title,
    showSellButton,
    onSellClick,
    buttonLabel,
    onBack,
    customButton,
    filters,
    search,
    tableProps,
    children,
    classes,
    alerts,
    headerContent,
    emptyDescription
}) => {
    return (
        <Box className={classes.wrapperContainer}>
            <Box className={classes.headWrapper}>
                <DefaultHeader
                    title={title}
                    displayButton={false}
                    onBack={onBack}
                    className={classes.headerContainer}
                    customButton={customButton}
                />

                {headerContent}

                <SelectionBar
                    options={filters.options}
                    selectedId={filters.selectedId}
                    onSelect={filters.onSelect}
                    className={filters.className}
                />

                {alerts && <Box className={classes.alertsContainer}>{alerts}</Box>}

                <SearchBar
                    searchText={search.value}
                    onChangeSearchText={search.setValue}
                    className={search.className}
                    placeholder={search.placeholder || ''}
                    rightActions={search.rightActions}
                />
            </Box>

            <Box className={classes.content}>
                <MembershipDetailsTable
                    {...tableProps}
                    emptyDescription={emptyDescription}
                />
            </Box>

            {children}
        </Box>
    );
};

export default EnrollmentListView;
